import { GridColDef } from '@mui/x-data-grid-pro';

import { IcDotSpread } from '@/assets/images';
import { Button } from '@/components/TailwindComponents';
import { VehicleStatus } from '@/models';

const vehicleName = (): Partial<GridColDef> => ({
  field: 'name',
  headerName: 'Vehicle name',
  renderCell: (params) => params.row.name || '-',
  sortable: true,
});

const make = (): Partial<GridColDef> => ({
  field: 'make',
  headerName: 'Make',
  renderCell: (params) => {
    if (typeof params.row.make === 'string') {
      return params.row.make || '-';
    }
    return params.row.make?.name || '-';
  },
  sortable: true,
});

const model = (): Partial<GridColDef> => ({
  field: 'model',
  headerName: 'Model',
  renderCell: (params) => {
    if (typeof params.row.model === 'string') {
      return params.row.model || '-';
    }
    return params.row.model?.name || '-';
  },
  sortable: true,
});

const year = (): Partial<GridColDef> => ({
  field: 'year',
  headerName: 'Year',
  renderCell: (params) => params.row.year || '-',
  sortable: true,
});

const vinNumber = (): Partial<GridColDef> => ({
  field: 'vin',
  headerName: 'VIN Number',
  renderCell: (params) => params.row.vin || '-',
  sortable: true,
});

const licensePlate = (): Partial<GridColDef> => ({
  field: 'licensePlate',
  headerName: 'License plate number',
  renderCell: (params) => {
    if (params.row.licensePlate?.number) {
      const state = params.row.licensePlate?.state
        ? ` - ${params.row.licensePlate.state}`
        : '';
      return `${params.row.licensePlate.number}${state}`;
    }
    return '-';
  },
  sortable: true,
});

const vehicleStatus = (): Partial<GridColDef> => ({
  field: 'status',
  headerName: 'Vehicle status',
  renderCell: (params) => {
    if (!params.row.status) return '-';

    const statusMap: Record<VehicleStatus, string> = {
      [VehicleStatus.ACTIVE]: 'Active',
      [VehicleStatus.INACTIVE]: 'Inactive',
    };

    return statusMap[params.row.status as VehicleStatus] || params.row.status;
  },
  sortable: true,
});

const actions = (
  openMenu?: (event: React.MouseEvent<HTMLButtonElement>, param: any) => void,
): Partial<GridColDef> => ({
  field: 'actions',
  headerName: 'Actions',
  sortable: false,
  renderCell: (params) => (
    <Button
      variant="ghost"
      size="sm"
      onClick={(e) => {
        e.stopPropagation();
        openMenu?.(e, params.row);
      }}
      className="p-1 h-8 w-8"
    >
      <IcDotSpread />
    </Button>
  ),
});

export const vehicleListCols = (
  openMenu?: (event: React.MouseEvent<HTMLButtonElement>, param: any) => void,
) => {
  return {
    vehicleName,
    make,
    model,
    year,
    vinNumber,
    licensePlate,
    vehicleStatus,
    actions: () => actions(openMenu),
  };
};
